import React from 'react'
import { observer } from 'mobx-react'
import { translate } from 'utils'
import XAxisTick from './XAxisTick'

const XAxis = ({ analysis, height, xScaleTranslate }) => (
  <g
    fill='none' className='axis x-axis'
    transform={translate(0, height)}
    style={{
      display: analysis.hoveredPyramid === null ? 'inherit' : 'none'
    }}
  >
    {
      analysis.pyramids.total.map(pyramid => (
        <XAxisTick
          key={pyramid.age}
          pyramid={pyramid}
          xScaleTranslate={xScaleTranslate}
        />
      ))
    }
  </g>
)

export default observer(XAxis)
